import React, { useState, useEffect } from 'react';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';

const ModalEditCategory = ({ isOpen, onClose, onSave, category }) => {
  const [formData, setFormData] = useState({ name: '', img_item: '' });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || '',
        img_item: category.img_item || ''
      });
    }
  }, [category]);

  const handleSave = () => {
    if (formData.name.trim()) {
      onSave({
        name: formData.name.trim(),
        img_item: formData.img_item.trim() || null
      });
      setFormData({ name: '', img_item: '' });
    }
  };

  const handleClose = () => {
    setFormData({ name: '', img_item: '' });
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <h2 className="text-xl font-bold mb-4 text-gray-900">Editar Categoría</h2>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nombre de la categoría
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            onKeyPress={handleKeyPress}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-4"
            placeholder="Ingresa el nombre de la categoría"
            autoFocus
          />
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL de la imagen (Opcional)
          </label>
          <input
            type="text"
            value={formData.img_item}
            onChange={(e) => setFormData({ ...formData, img_item: e.target.value })}
            onKeyPress={handleKeyPress}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="https://ejemplo.com/imagen.jpg"
          />
        </div>
        
        <div className="flex justify-end space-x-3">
          <GrayButton onClick={handleClose}>
            Cancelar
          </GrayButton>
          <BlackButton 
            onClick={handleSave}
            disabled={!formData.name.trim()}
          >
            Guardar Cambios
          </BlackButton>
        </div>
      </div>
    </div>
  );
};

export default ModalEditCategory;
